<template>
    <div>
        <div v-bind:id="setId" v-bind:style="{width: chartWidth,height: chartHeight}"></div>
    </div>
</template>
<script>
import echarts from "echarts";
export default {
  data() {
    return {
      charts: "",
      opinionData: []
    };
  },
  props: ["getData", "chartWidth", "chartHeight", "setId"],
  methods: {
    dealSeries: function() {
      let data = [];
      console.log(this.getData);
      let income = [];
      let profit = [];
      let avg = [];
      income.push(this.getData.list.income);
      profit.push(this.getData.list.profit);
      let mapList={
        costHold:'Cost Hold',
        costOrderCount:'Cost Order Count',
        costSales:'Cost Sales',
        costTrans:'Cost Trans',
      };
      avg.push(this.getData.list.avg);
      for(var i = 0; i < this.getData.list.length; i++){
        data.push({
          name: mapList[this.getData.list[i].name],
          type: "bar",
          stack: 'one',
          label:{
              show:false,
              position:'insideTop',
              color:'#333'
          },
          barWidth: "30%",
          data:this.getData.list[i].data
        });
      }
      return data;
    },
    drawPie: function(id) {
      let that = this;
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "item",
          formatter:function(parames){
            return '目标天数 : '+ parames.name + '<br />'+ parames.seriesName + ' : ' + parames.value;
          }
        },
        legend: {
          icon: "rect",
          itemWidth: 10,
          itemHeight: 10,
          bottom: -5,
          data: ["Cost Hold", "Cost Order Count", "Cost Sales", "Cost Trans"]
        },
        grid: {
          top: 30,
          left: 70,
          right: 60,
          bottom: 30
        },
        color: ["#4e79a7", "#edc948", "#e15759","#76b7b2"],
        xAxis: [
          {
            name: "目标天数",
            nameTextStyle: {
              fontSize: 10,
              padding: [-20, 0, 0, 0]
            },
            offset: 10,
            type: "category",
            boundaryGap: true,
            axisTick: {
              show: false
            },
            axisLabel: {
              padding: [-15, 0, 0, 0]
            },
            data: this.getData.day
          }
        ],
        yAxis: [
          {
            name: "",
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, -5, 0]
            },
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            },
             axisLabel:{
              show: true
            }
          },
          {
            name: "",
            nameTextStyle: {
              fontSize: 10,
              padding: [0, 0, -5, 0]
            },
            type: "value",
            axisLine: {
              show: false
            },
            axisTick: {
              show: false
            }
          }
        ],
        series: this.dealSeries()
      });
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      //this.dealSeries();
      this.drawPie(this.setId);
    });
  },
  watch:{
        getData(val){    
          this.drawPie(this.setId);
        }
      }
};
</script>




// WEBPACK FOOTER //
// src/components/common/chart3.vue